export function userHasBio(user) {
    return !!user?.description?.length;
}
